import _classCallCheck from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { Field } from 'react-final-form';
import formatString from 'format-string-by-pattern';
import { FieldLabel } from './FieldLabel';
import { FieldError } from './FieldError';
export var COUNTRY;

(function (COUNTRY) {
  COUNTRY["RU"] = "+7";
})(COUNTRY || (COUNTRY = {}));

var MobilePhoneField = function () {
  var MobilePhoneField = /*#__PURE__*/function (_React$Component) {
    _inherits(MobilePhoneField, _React$Component);

    var _super = _createSuper(MobilePhoneField);

    function MobilePhoneField() {
      _classCallCheck(this, MobilePhoneField);

      return _super.apply(this, arguments);
    }

    _createClass(MobilePhoneField, [{
      key: "getMask",
      value: function getMask() {
        switch (this.props.country) {
          case COUNTRY.RU:
          default:
            return '(999) 999-99-99';
        }
      }
    }, {
      key: "parser",
      value: function parser(value) {
        var country = this.props.country;
        var mask = this.getMask();

        if (typeof value === 'string') {
          var countryRegExp = new RegExp('^\\' + country + '|([^\\d])', 'g');
          value = value.replace(countryRegExp, '');
        }

        return formatString(mask)(value);
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        var _this$props = this.props,
            name = _this$props.name,
            isRequired = _this$props.isRequired,
            isReadonly = _this$props.isReadonly,
            initialValue = _this$props.initialValue,
            placeholder = _this$props.placeholder,
            label = _this$props.label;
        return React.createElement(Field, {
          name: name,
          parse: this.parser.bind(this),
          initialValue: this.parser(initialValue),
          render: function render(_ref) {
            var input = _ref.input,
                meta = _ref.meta;
            return React.createElement(Form.Group, {
              controlId: name
            }, React.createElement(FieldLabel, Object.assign({}, label, {
              isRequired: isRequired
            })), React.createElement(InputGroup, null, React.createElement(InputGroup.Prepend, null, React.createElement(Button, {
              disabled: true,
              variant: 'secondary'
            }, _this.props.country)), React.createElement(Form.Control, Object.assign({}, input, {
              placeholder: placeholder || _this.getMask(),
              readOnly: isReadonly,
              isInvalid: FieldError.isInvalid(meta)
            })), React.createElement(FieldError, {
              error: meta.error
            })));
          }
        });
      }
    }]);

    return MobilePhoneField;
  }(React.Component);

  MobilePhoneField.defaultProps = {
    country: COUNTRY.RU,
    isReadonly: false,
    isRequired: false
  };
  return MobilePhoneField;
}();

export { MobilePhoneField };